module.exports = __webpack_public_path__ + "img/comment_3_1.f9b752ac.jpg";